'use client';

import { Button } from '@/comps/primitives/button';
import { Separator } from '@/comps/primitives/separator';
import Link from 'next/link';

export default function NotFoundPage() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-8">
      <div className="flex items-center gap-2">
        <h3 className="text-3xl font-bold">404</h3>
        <Separator orientation="vertical" className="h-full bg-white" />
        <h3 className="text-xl">Could not find the page</h3>
      </div>
      <Link href={'/reports'}>
        <Button variant={'ghost'}>Go to main page</Button>
      </Link>
    </div>
  );
}
